import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';

export const ScoreEvaluationStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: 'calc(100vh - 40px - 165px)',
      padding: '2rem 0rem',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px - 165px)',
        padding: '2.5rem 0',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '5rem 0',
      },
    },
  }),
);
